import * as React from 'react';
const { connect } = require('react-redux');
import { translate } from 'react-i18next';
import { browserHistory } from 'react-router';
import { IStore } from 'redux/IStore';
import { Field, reduxForm, change, getFormSyncErrors } from 'redux-form';
import * as c from 'models/constants';
import { LoadingOverlayWrapper } from 'components';
import { closeModal, showModal } from 'redux/modules/modal';
import { PortalPageSection } from 'components/PortalStructure';
import renderIcon from 'helpers/renderIcon';

import { IOnboardingQuizFormData } from 'models/onboardingquiz';
import { BasicButton } from 'components/Common/Button';
import { Dispatch } from 'react-redux';
import { updateShopCustomer } from 'redux/modules/shop/shopcard';
import { ICustomer } from 'models/shop/customer';

interface IProps extends ReturnType<typeof mapStateToProps>, ReturnType<typeof mapDispatchToProps> {
	location: any;

	/* form props */
	pristine: boolean;
	dirty: boolean;
	submitting: boolean;
	handleSubmit: any;
	submitFailed: boolean;

	/* functions props */
	t?: (key: string, props?: any) => string;
	reset: () => void;

	/* other props */
	customCardClassName?: string;
}

interface IState {
	readOnlyBio: boolean;
	readOnlyProfile: boolean;
}

const modalToFieldsMap = {
	HairLength: ['hairLength'],
	HairColor: ['hairColor', 'coloredHair'],
	HairType: ['hairType'],
	ScalpCondition: ['scalpMoisture', 'hairProducts'],
	ProductBrand: ['brands'],
	HairRelatedGoal: ['goals'],
	SkinProblem: ['skinProblems'],
	EyeColor: ['eyesColor', 'eyebrowType'],
	NailsShape: ['nailShape'],
};

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ShopCustomerBioForm extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);

		this.onSubmit = this.onSubmit.bind(this);
		this.onSubmitModal = this.onSubmitModal.bind(this);
		this.cancelClick = this.cancelClick.bind(this);
		this.toggleReadOnlyBio = this.toggleReadOnlyBio.bind(this);
		this.toggleReadOnlyProfile = this.toggleReadOnlyProfile.bind(this);
		this.openModal = this.openModal.bind(this);

		this.state = {
			readOnlyBio: true,
			readOnlyProfile: true,
		};
	}

	public onSubmitModal(form: IOnboardingQuizFormData, type: keyof typeof modalToFieldsMap) {
		const modifiedForm: ICustomer = {
			...this.props.selectedCustomer,
		};
		for (const field of modalToFieldsMap[type]) {
			modifiedForm[field] = form[field];
		}
		// this.populateQuizForm();
		this.props.updateShopCustomer(modifiedForm);
	}

	public onSubmit(form: ICustomer) {
		this.props.updateShopCustomer(form);
	}

	private cancelClick() {
		browserHistory.push('/');
	}

	private toggleReadOnlyBio() {
		this.setState((s) => {
			this.props.reset();
			return {
				readOnlyBio: !s.readOnlyBio,
				readOnlyProfile: true,
			};
		});
	}

	private toggleReadOnlyProfile() {
		this.setState((s) => {
			this.props.reset();
			return {
				readOnlyProfile: !s.readOnlyProfile,
				readOnlyBio: true,
			};
		});
	}

	private openModal(type: keyof typeof modalToFieldsMap) {
		this.props.showModal('OnboardingQuizEdit', {
			closeModal: this.props.closeModal,
			showHeaderCloseButton: true,
			showModal: this.props.showModal,
			componentName: type,
			onSubmit: (result: IOnboardingQuizFormData) => this.onSubmitModal(result, type),
		});
	}

	private renderReadOnlyHair() {
		const { t, currentFormValues } = this.props;
		const hairProductsJoined = currentFormValues?.hairProducts
			?.map((key) => ' ' + t(`DV_HairProduct_${key}`))
			.toString();
		const hairRelatedGoalJoined = currentFormValues?.goals?.map((key) => ' ' + t(`DV_Goals_${key}`)).toString();

		return (
			<dl className="list">
				<dt>{t('User_UserProfile_Label_HairType')}</dt>
				<dd>
					<BasicButton onClick={() => this.openModal('HairType')}>
						{currentFormValues?.hairType ? (
							<span>{t(`DV_HairTypes_${currentFormValues?.hairType}`)}</span>
						) : (
							<span className="not-selected">{t('User_UserProfile_Label_NotSelected')}</span>
						)}
						{renderIcon('search_go')}
					</BasicButton>
				</dd>
				<dt>{t('User_UserProfile_Label_HairLength')}</dt>
				<dd>
					<BasicButton onClick={() => this.openModal('HairLength')}>
						{currentFormValues?.hairLength ? (
							<span>{t(`DV_HairLengths_${currentFormValues?.hairLength}`)}</span>
						) : (
							<span className="not-selected">{t('User_UserProfile_Label_NotSelected')}</span>
						)}
						{renderIcon('search_go')}
					</BasicButton>
				</dd>
				<dt>{t('User_UserProfile_Label_HairColor')}</dt>
				<dd>
					<BasicButton onClick={() => this.openModal('HairColor')}>
						{currentFormValues?.hairColor ? (
							<span>{t(`DV_HairColors_${currentFormValues?.hairColor}`)}</span>
						) : (
							<span className="not-selected">{t('User_UserProfile_Label_NotSelected')}</span>
						)}
						{renderIcon('search_go')}
					</BasicButton>
				</dd>
				<dt>{t('User_UserProfile_Label_ColoredHair')}</dt>
				<dd>
					<BasicButton onClick={() => this.openModal('HairColor')}>
						{currentFormValues?.coloredHair ? (
							<span>{t('BSPortal_Common_Yes')}</span>
						) : currentFormValues?.coloredHair ? (
							<span>{t('BSPortal_Common_No')}</span>
						) : (
							<span className="not-selected">{t('User_UserProfile_Label_NotSelected')}</span>
						)}
						{renderIcon('search_go')}
					</BasicButton>
				</dd>
				<dt>{t('User_UserProfile_Label_ScalpCondition')}</dt>
				<dd>
					<BasicButton onClick={() => this.openModal('ScalpCondition')}>
						{currentFormValues?.scalpMoisture ? (
							<span>{t(`DV_ScalpMoisture_${currentFormValues?.scalpMoisture}`)}</span>
						) : (
							<span className="not-selected">{t('User_UserProfile_Label_NotSelected')}</span>
						)}
						{renderIcon('search_go')}
					</BasicButton>
				</dd>
				<dt>{t('User_UserProfile_Label_HairProducts')}</dt>
				<dd>
					<BasicButton onClick={() => this.openModal('ScalpCondition')}>
						{hairProductsJoined ? (
							<span>{hairProductsJoined}</span>
						) : (
							<span className="not-selected">{t('User_UserProfile_Label_NotSelected')}</span>
						)}
						{renderIcon('search_go')}
					</BasicButton>
				</dd>
				<dt>{t('User_UserProfile_Label_Goals')}</dt>
				<dd>
					<BasicButton onClick={() => this.openModal('HairRelatedGoal')}>
						{hairRelatedGoalJoined ? (
							<span>{hairRelatedGoalJoined}</span>
						) : (
							<span className="not-selected">{t('User_UserProfile_Label_NotSelected')}</span>
						)}
						{renderIcon('search_go')}
					</BasicButton>
				</dd>
			</dl>
		);
	}

	private renderReadOnlySkin() {
		const { t, currentFormValues } = this.props;

		const skinProblemsJoined = currentFormValues?.skinProblems
			?.map((key) => ' ' + t(`DV_SkinProblems_${key}`))
			.toString();

		return (
			<dl className="list">
				<dt>{t('User_UserProfile_Label_SkinProblem')}</dt>
				<dd>
					<BasicButton onClick={() => this.openModal('SkinProblem')}>
						{skinProblemsJoined ? (
							<span>{skinProblemsJoined}</span>
						) : (
							<span className="not-selected">{t('User_UserProfile_Label_NotSelected')}</span>
						)}
						{renderIcon('search_go')}
					</BasicButton>
				</dd>
			</dl>
		);
	}

	private renderReadOnlyEyes() {
		const { t, currentFormValues } = this.props;

		return (
			<dl className="list">
				<dt>{t('User_UserProfile_Label_EyeColor')}</dt>
				<dd>
					<BasicButton onClick={() => this.openModal('EyeColor')}>
						{currentFormValues?.eyesColor ? (
							<span>{t(`DV_EyesColors_${currentFormValues?.eyesColor}`)}</span>
						) : (
							<span className="not-selected">{t('User_UserProfile_Label_NotSelected')}</span>
						)}
						{renderIcon('search_go')}
					</BasicButton>
				</dd>
				<dt>{t('User_UserProfile_Label_EyebrowType')}</dt>
				<dd>
					<BasicButton onClick={() => this.openModal('EyeColor')}>
						{currentFormValues?.eyebrowType ? (
							<span>{t(`DV_EyebrowTypes_${currentFormValues?.eyebrowType}`)}</span>
						) : (
							<span className="not-selected">{t('User_UserProfile_Label_NotSelected')}</span>
						)}
						{renderIcon('search_go')}
					</BasicButton>
				</dd>
			</dl>
		);
	}

	private renderReadOnlyNails() {
		const { t, currentFormValues } = this.props;

		return (
			<dl className="list">
				<dt>{t('User_UserProfile_Label_NailsShape')}</dt>
				<dd>
					<BasicButton onClick={() => this.openModal('NailsShape')}>
						{currentFormValues?.nailShape ? (
							<span>{t(`DV_NailShapes_${currentFormValues?.nailShape}`)}</span>
						) : (
							<span className="not-selected">{t('User_UserProfile_Label_NotSelected')}</span>
						)}
						{renderIcon('search_go')}
					</BasicButton>
				</dd>
			</dl>
		);
	}

	private renderReadOnlyFavouriteBrands() {
		const { t, currentFormValues } = this.props;
		const brandsJoined = currentFormValues?.brands?.map((key) => ' ' + t(`DV_Brands_${key}`)).toString();

		return (
			<dl className="list">
				<dt>{t('User_UserProfile_Label_Brands')}</dt>
				<dd>
					<BasicButton onClick={() => this.openModal('ProductBrand')}>
						{brandsJoined ? (
							<span>{brandsJoined}</span>
						) : (
							<span className="not-selected">{t('User_UserProfile_Label_NotSelected')}</span>
						)}
						{renderIcon('search_go')}
					</BasicButton>
				</dd>
			</dl>
		);
	}

	/** --------------RENDER ----------------------- */
	public render() {
		const { handleSubmit, t, customCardClassName } = this.props;

		return (
			<>
				<div className="userProfileEditForm">
					<LoadingOverlayWrapper
						active={this.props.shopcard.isFetching}
						spinner={true}
						text={t('BSPortal_Common_Loading')}
						background="rgba(0, 0, 0, 0.1)"
					>
						{/* <div className="profileError">
              <ErrorSummary {...errorSummaryProps} />
            </div> */}
						<form onSubmit={handleSubmit(this.onSubmit)} className="editForm">
							<Field name="id" component="input" type="hidden" />
							<PortalPageSection
								title={t('User_UserProfile_Hair')}
								variant="dark"
								className={`${customCardClassName ? customCardClassName : ''}`}
							>
								{this.renderReadOnlyHair()}
							</PortalPageSection>
							<PortalPageSection
								title={t('User_UserProfile_Skin')}
								variant="dark"
								className={`${customCardClassName ? customCardClassName : ''}`}
							>
								{this.renderReadOnlySkin()}
							</PortalPageSection>
							<PortalPageSection
								title={t('User_UserProfile_Eyes')}
								variant="dark"
								className={`${customCardClassName ? customCardClassName : ''}`}
							>
								{this.renderReadOnlyEyes()}
							</PortalPageSection>
							<PortalPageSection
								title={t('User_UserProfile_Nails')}
								variant="dark"
								className={`${customCardClassName ? customCardClassName : ''}`}
							>
								{this.renderReadOnlyNails()}
							</PortalPageSection>
							<PortalPageSection
								title={t('User_UserProfile_Label_Brands')}
								variant="dark"
								className={`${customCardClassName ? customCardClassName : ''}`}
							>
								{this.renderReadOnlyFavouriteBrands()}
							</PortalPageSection>
						</form>
					</LoadingOverlayWrapper>
				</div>
			</>
		);
	}
}

let ShopCustomerBio = reduxForm({
	form: c.FORM_NAME_ONBOARDING_QUIZ,
	enableReinitialize: true,
	onSubmit: updateShopCustomer,
})(ShopCustomerBioForm);

const mapStateToProps = (state: IStore) => {
	let currentFormValues: ICustomer = null;
	if (state.form[c.FORM_NAME_ONBOARDING_QUIZ] && state.form[c.FORM_NAME_ONBOARDING_QUIZ].values) {
		currentFormValues = state.form[c.FORM_NAME_ONBOARDING_QUIZ].values;
	} else {
		currentFormValues = state.shopcard?.selectedCustomer;
	}
	const selectedCustomer = state.shopcard?.selectedCustomer;
	const initialValues = selectedCustomer ? { ...selectedCustomer } : selectedCustomer;

	return {
		allForms: state.form,
		initialValues,
		shopcard: state.shopcard,
		selectedCustomer: state.shopcard.selectedCustomer,
		currentFormValues,
		formErrors: getFormSyncErrors(c.FORM_NAME_ONBOARDING_QUIZ)(state),
		baseUrlClient: state.fetchDefault.baseUrlClient,
	};
};
const mapDispatchToProps = (dispatch: Dispatch<IStore>) => ({
	updateShopCustomer: (newData: Partial<ICustomer>) => dispatch(updateShopCustomer(newData)),
	change: (field: string, value: any) => dispatch(change(field, value)),
	showModal: (type: string, modalProps: any) => dispatch(showModal(type, modalProps)),
	closeModal: () => dispatch(closeModal()),
	dispatch,
});

ShopCustomerBio = connect(mapStateToProps, mapDispatchToProps)(ShopCustomerBio);

export { ShopCustomerBio };
